import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import H1 from 'shared/app/components/h1';
import {
  isPromoRedeemRequestSelector,
  getPartnershipSelector,
} from 'shared/app/state/selectors/return-url-selectors';
import PartnershipHeader from './partnership-header';

import messages from './messages';

export const Header = () => {
  const { formatMessage } = useIntl();
  const partnership = useSelector(getPartnershipSelector);
  const isPromoRedeemRequest = useSelector(isPromoRedeemRequestSelector);

  if (partnership) {
    return <PartnershipHeader partnership={partnership} />;
  }

  const currentHeaderMessage = isPromoRedeemRequest
    ? messages.signInPromoHeader
    : messages.signInHeaderStandard;
  return (
    <H1 className="text-bold text-center mb2" size="lg">
      {formatMessage(currentHeaderMessage)}
    </H1>
  );
};

export default Header;
